import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=988bcafc&scoped=true&"
import script from "./GlobalMenu.vue?vue&type=script&lang=js&"
export * from "./GlobalMenu.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=988bcafc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988bcafc",
  null
  
)

export default component.exports